import SelfReviewComp from '../../Components/EmployeesReview/SelfReviewComp';

function SelfReview() {
  return <SelfReviewComp />;
}

export default SelfReview;
